import * as React from 'react'

import moment from 'moment'
import { formatDateTime, getDurationBetweeenDates } from 'app/common/dateHelper'
import { ExistingDelegationModel } from 'app/models/existingDelegationModel'
import { TooltipLayout } from './ToolTipLayout'

type ExistingDelegationItemTooltipProps = {
  existingDelegation: ExistingDelegationModel
  translate: (text) => any
}
type ExistingDelegationItemTooltipState = {}

export class ExistingDelegationItemTooltip extends React.Component<
  ExistingDelegationItemTooltipProps,
  ExistingDelegationItemTooltipState
> {
  constructor(props: ExistingDelegationItemTooltipProps) {
    super(props)
  }

  render() {
    const { delegationNumber, startTime, endTime, destinationCountryName } =
      this.props.existingDelegation

    const rows = [
      {
        title: this.props.translate('newDelegation.tooltip.number'),
        value: delegationNumber,
      },
      {
        title: this.props.translate(
          'newDelegation.tooltip.destinationCountryName',
        ),
        value: destinationCountryName,
      },
      {
        title: this.props.translate('newDelegation.tooltip.startTime'),
        value: formatDateTime(startTime),
      },
      {
        title: this.props.translate('newDelegation.tooltip.endTime'),
        value: formatDateTime(endTime),
      },
      {
        title: this.props.translate('newDelegation.tooltip.duration'),
        value: getDurationBetweeenDates(
          moment(startTime).toDate(),
          moment(endTime).toDate(),
        ),
      },
    ]

    return (
      <TooltipLayout
        headerColor="#D789FF"
        headerTitle={this.props.translate('newDelegation.tooltip.delegation')}
        rows={rows}
      />
    )
  }
}
